import React, { useContext, useEffect, useRef, useState } from "react";
import "./AdvanceDashboard.css";
import Header from "../../Header/Header";
import { Link, useNavigate } from "react-router-dom";
import Dashboard_LineChart from "./Dashboard_LineChart/Dashboard_LineChart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendDown,
  faArrowTrendUp,
  faCalendarCheck,
  faCartFlatbed,
  faChartSimple,
  faCircleUser,
  faComments,
  faExclamationCircle,
  faGlobe,
  faIndustry,
  faLightbulb,
  faMessage,
  faPhone,
  faRepeat,
  faTape,
  faTrash,
  faUser,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { Table } from "react-bootstrap";
import Rating from "@material-ui/lab/Rating";
import { Context } from "../../../utils/context";
import { faJediOrder } from "@fortawesome/free-brands-svg-icons";
import { RoleId } from "../../../utils/common";
import { deleteData } from "../../../utils/api";

function AdvanceDashboard() {


  const [value, setValue] = useState(2);
  const navigate = useNavigate();
  const { getData, usertype } = useContext(Context);
  const [result, setResult] = useState({});
  const [pieData, setPieData] = useState();
  const [avgRating, setAvgRating] = useState(null);
  const [statusCounts, setStatusCounts] = useState({});
  const [chartData, setChartData] = useState({});
  const [user, setUser] = useState({});
  const [data, setData] = useState([]);
  const [removingId, setRemovingId] = useState(null);
  const [doctor, setDoctor] = useState({});

  const getDataAll = async () => {
    const result = await getData("/admin/dashboard/dashboard-data");
    setStatusCounts(result?.data);
  };
  const getDataDoctor = async () => {
    const result = await getData("/admin/dashboard/doctor-wallet");
    setDoctor(result?.data);
  };

  const getChartData = async () => {
    const result = await getData("/admin/dashboard/sales-chart");
    setChartData(result.data);
  };


  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      await setUser(response?.data);
    }
  };

  const getnotification = async () => {
    const response = await getData(`/admin/notification`);

    if (response?.success) {
      await setData(response?.data?.data);
    }
  };

  const deletenotification = async (id) => {
    if (!id) return;
    setRemovingId(id);
    setTimeout(async () => {
      try {
        const response = await deleteData(`/admin/notification/${id}`);
       
        if (response?.success) {
          setData((prev) => prev.filter((item) => item.id !== id));
        }
      } catch (error) {
        console.error("Delete notification error:", error);
      } finally {
        setRemovingId(null);
      }
    }, 400);
  };

  useEffect(() => {
    getDataAll();
    getChartData();
    GetUser();
    getDataDoctor();
    getnotification();
    deletenotification();
  }, []);

  // console.log(statusCounts," statusCountsstatusCounts ++")
  const totalOrders =
  (statusCounts?.Processing_orders || 0) +
  (statusCounts?.pickup || 0)+
  (statusCounts?.Preparing || 0) +
  (statusCounts?.OrderUnderQualityCheck || 0) +
  (statusCounts?.Delivered_orders || 0) +
  (statusCounts?.Rejected_orders || 0) + 
  (statusCounts?.Returned_orders || 0);


  return (
    <div>
      <div className="main-advancedashboard">
        <section className="AdvanceDashboard">
          <div className="AdvanceDashboardTabs">
            <Header title={"Dashboard"} link={"/masters/social_links"} />
            <div className=""></div>
          </div>
        </section>
        {user.role_id === RoleId.Doctor && (
          <div className="col-xl-12 col-lg-12">
            <div className="Main-Section-Advanced-Dashboard">
              <div className="row">
                <div className="col-xl-3 col-lg-4">
                  <div className="bucket-card-holder">
                    <div className="second_card_holder">
                      <h6 className="title">Wallet Amount</h6>
                      <div className="inner_div">
                        <div className="top_heading">
                          <div className="icon_holder">
                            <FontAwesomeIcon className="icon" icon={faWallet} />
                          </div>
                          <div className="text_holder">
                            <p className="text">Wallet Amount</p>
                          </div>
                        </div>

                        <div className="count_holder">
                          <p className="count"> {doctor?.wallet?.amount}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-lg-4">
                  <div className="bucket-card-holder">
                    <div className="second_card_holder">
                      <h6 className="title">Appointment</h6>
                      <div
                        className="inner_div"
                        onClick={() => {
                          navigate("/subscription/appointment");
                        }}
                      >
                        <div className="top_heading">
                          <div className="icon_holder">
                            <FontAwesomeIcon
                              className="icon"
                              icon={faCircleUser}
                            />
                          </div>
                          <div className="text_holder">
                            <p className="text">Appointment</p>
                          </div>
                        </div>

                        <div className="count_holder">
                          <p className="count">
                            {" "}
                            {doctor?.appointment?.length}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bucket-card-holder">
                    <div className="second_card_holder">
                      <h6 className="title">Doctor Code</h6>
                      <div className="inner_div">
                        <div className="top_heading">
                          <div className="icon_holder">
                            <FontAwesomeIcon
                              className="icon"
                              icon={faCircleUser}
                            />
                          </div>
                          <div className="text_holder">
                            <p className="text">Doctor Code</p>
                          </div>
                        </div>

                        <div className="count_holder">
                          <p className="count">
                            {" "}
                            {doctor?.doctor?.doctor_code}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {user.role_id === RoleId.Admin && (
          <div className="Main-Section-Advanced-Dashboard">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  {/* Products Card */}
                  <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                    <div
                      className="bucket-card-holder"
                      onClick={() => {
                        user?.Store_Detail?.s_category?.is_restaurant_flow
                          ? navigate("/Foods/:id")
                          : navigate("/products");
                      }}
                    >
                      <div className="second_card_holder">
                        <h6 className="title">Products</h6>
                        <div className="inner_div">
                          <div className="top_heading">
                            <div className="icon_holder">
                              <FontAwesomeIcon className="icon" icon={faChartSimple} />
                            </div>
                            <div className="text_holder">
                              <p className="text">Total Products</p>
                            </div>
                          </div>
                          <div className="count_holder">
                            <p className="count">{statusCounts?.total_products}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Stock Card */}
                  <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                    <div
                      className="bucket-card-holder"
                      onClick={() => navigate("/product/product-stock")}
                    >
                      <div className="second_card_holder">
                        <h6 className="title">Stock</h6>
                        <div className="inner_div">
                          <div className="top_heading">
                            <div className="icon_holder">
                              <FontAwesomeIcon className="icon" icon={faArrowTrendUp} />
                            </div>
                            <div className="text_holder">
                              <p className="text">Product Stock</p>
                            </div>
                          </div>
                          {/* <div className="count_holder">
                            <p className="count">{statusCounts?.total_stock || 0}</p>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Customer Feedback Card - Unified Design */}
                  <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                    <div
                      className="bucket-card-holder"
                      onClick={() => navigate("/product/ratings/:id")}
                    >
                      <div className="second_card_holder">
                        <h6 className="title">Customer Feedback</h6>
                        <div className="inner_div">
                          <div className="top_heading">
                            <div className="icon_holder">
                              <FontAwesomeIcon className="icon" icon={faUser} />
                            </div>
                            <div className="text_holder">
                              <p className="text">Total Messages</p>
                            </div>
                          </div>
                          <div className="count_holder">
                            <p className="count">{statusCounts?.total_reviews || 0}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Today's Payment Card - Unified Design */}
                  <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                    <div className="bucket-card-holder">
                      <div className="second_card_holder">
                        <h6 className="title">Total</h6>
                        <div className="inner_div">
                          <div className="top_heading">
                            <div className="icon_holder">
                              <FontAwesomeIcon className="icon" icon={faWallet} />
                            </div>
                            <div className="text_holder">
                              <p className="text">Today's Payment</p>
                            </div>
                          </div>
                          <div className="count_holder">
                            <p className="count">{statusCounts?.todays_total || "0.00"}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Total Customer Card - Unified Design */}
                  <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                    <div
                      className="bucket-card-holder"
                      onClick={() => navigate("/customers")}
                    >
                      <div className="second_card_holder">
                        <h6 className="title">Total Customer</h6>
                        <div className="inner_div">
                          <div className="top_heading">
                            <div className="icon_holder">
                              <FontAwesomeIcon className="icon" icon={faUser} />
                            </div>
                            <div className="text_holder">
                              <p className="text">Total Customer</p>
                            </div>
                          </div>
                          <div className="count_holder">
                            <p className="count">{statusCounts?.TotalCustomer || 0}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-6 col-lg-12 mb-3">
                    <div className="bucket-card-holder">
                      <div className="card-heading-holder">
                        <h6>Sales</h6>
                      </div>
                      <div className="card-number-holder">
                        <h3>{chartData?.total}</h3>
                        <p>This month</p>
                      </div>
                      <div className="card-chart-holder">
                        <Dashboard_LineChart chartData={chartData?.data} />
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-lg-12 mb-3">
                    <div
                      className="bucket-card-holder"
                      onClick={() => navigate("/orders/all-orders")}
                    >
                      <div className="card-heading-holder">
                        <h6>Today's Orders</h6>
                      </div>
                      <div className="card-number-holder">
                        <div className="icon_holder">
                          <FontAwesomeIcon className="inner_icon" icon={faCartFlatbed} />
                        </div>
                        <div className="text_holder">
                          {/* <h3 className="count_text">{statusCounts?.total_Orders }</h3> */}
                          <h3 className="count_text">{totalOrders }</h3>

                          <h3 className="title_text">Today Count</h3>
                        </div>
                      </div>
                      <div className="card-table-holder">
                        <Table className="mb-0">
                          <tbody>
                            <tr>
                              <td>Processing Orders</td>
                              <td className="num">{statusCounts?.Processing_orders}</td>
                            </tr>
                            <tr>
                              <td>Preparing Orders</td>
                              <td className="num">{statusCounts?.Preparing}</td>
                            </tr>
                            <tr>
                              <td>Order Under QualityCheck Orders</td>
                              <td className="num">{statusCounts?.OrderUnderQualityCheck}</td>
                            </tr>
                             <tr>
                              <td>Pickup Orders</td>
                              <td className="num">{statusCounts?.pickup || 0}</td>
                            </tr>
                            <tr>
                              <td>Delivered Orders</td>
                              <td className="num">{statusCounts?.Delivered_orders}</td>
                            </tr>
                            <tr>
                              <td>Cancelled Orders</td>
                              {/* <td className="num">{statusCounts?.Cancelled_orders}</td> */}
                               <td className="num">{statusCounts?.Rejected_orders}</td>
                            </tr>
                            <tr>
                              <td>Returned Orders</td>
                              {/* <td>Cancelled Orders</td> */}
                              {/* <td className="num">{statusCounts?.Rejected_orders}</td> */}
                              <td className="num">{statusCounts?.Returned_orders}</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-lg-12 mb-3">
                    <div className="bucket-card-holder">
                      <div className="card-heading-holder">
                        <h6>Notification</h6>
                      </div>

                      <div className="notification_list">
                        {data?.length > 0 ? (
                          data.map((item) => (
                            <div
                              className="notification-box bucket-card-holder card-heading-holder"
                              key={item.id}
                            >
                              <h6 className="notification_name">
                                {item?.name}
                                <span onClick={() => deletenotification(item.id)}>
                                  <FontAwesomeIcon icon={faTrash} />
                                </span>
                              </h6>
                              <p className="notification_subname">{item?.message}</p>
                            </div>
                          ))
                        ) : (
                          <div className="no-notification">
                            <p>No notifications found.</p>
                          </div>
                        )}
                      </div>




                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdvanceDashboard;